import { createSlice } from "@reduxjs/toolkit";
import { rejectPharmacyOrder } from "../../reducer/rejectPharmacyOrder/rejectPharmacyOrderReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const rejectPharmacyOrderSlice = createSlice({
  name: "rejectPharmacyOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rejectPharmacyOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(rejectPharmacyOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(rejectPharmacyOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default rejectPharmacyOrderSlice.reducer;
